import { useRef } from "react";
import { lerp, unlerp } from "../Util";
import { HOUR_MAX, HOUR_MIN } from "../Config";

import playIcon from '../../public/images/play-solid.svg';
import pauseIcon from '../../public/images/pause-solid.svg';

export function getHourNormalized(hour) {
	return unlerp(hour, HOUR_MIN, HOUR_MAX);
}
export function getHourFromHourNormalized(hourNormalized) {
	return lerp(hourNormalized, HOUR_MIN, HOUR_MAX);
}
export function getTimeStringFromHourNormalized(hourNormalized) {
	const timeFloat = getHourFromHourNormalized(hourNormalized);
	const hours = Math.trunc(timeFloat);
	const minutesRaw = (timeFloat - hours) * 60.0;
	const minutes = Math.trunc(minutesRaw / 15.0) * 15.0; // snapped to 15mins
	return `${('0' + hours).slice(-2)}:${('0' + minutes).slice(-2)}`; // fromat hh:mm
}

export function DaytimePlayer({
	hourNormalized = 0.5,
	setHourNormalized = ()=>{},
	autoplayEnabled = false,
	setAutoplayEnabled = ()=>{}
}) {
	const icon = autoplayEnabled ? pauseIcon : playIcon;
	const iconAlt = autoplayEnabled ? 'Disable Autoplay Time' : 'Enable Autoplay Time';
	const slider = useRef();

	const toggleAutoplay = () => setAutoplayEnabled(!autoplayEnabled);
	const sliderOnChange = () => {
		setHourNormalized(slider.current.value);
		setAutoplayEnabled(false);
	};

	const time = getTimeStringFromHourNormalized(hourNormalized);

	return <div className="daytime-player">
		<div className="button autoplay-toggle" onClick={toggleAutoplay}>
			<img src={icon} alt={iconAlt} />
		</div>
		<div className="button autoplay-timeline">
			<input ref={slider} type="range" value={hourNormalized} min={0} max={1} step="any" onChange={sliderOnChange} />
		</div>
		<div className="button autoplay-time">{time}</div>
	</div>;
}
